import React from 'react'
import {Row, Col, Container} from 'reactstrap'
import SocialLinks from '../SocialLinks/SocialLinks'

function Footer() {
  return (
    <footer className="Footer py-4">
      <Container>
        <Row className="align-items-center">
          <SocialLinks/>
          <Col md="4" className="text-center mb-3 mb-md-0">
            <p className="mb-0">&copy; {new Date().getFullYear()} Content. All rights reserved.</p>
          </Col>
          <Col md="4" className="text-center text-md-right">
            <a href="https://katherineebel.com" target="_blank" rel="noopener noreferrer">
              <span style={{color: '#463229'}}>Website by Katherine Ebel</span>
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer

